import { useQuery } from "@tanstack/react-query";
import { RoleShell } from "./RoleShell";
import { ShareIntakeLinkButton } from "./ShareIntakeLinkButton";
import { affiliateApi } from "../lib/api";
import { identityKycNavLabel, identityMarketplaceOpen } from "../lib/kyc";
import { NAV_COPY, NAV_ICONS } from "../lib/navCopy";

const NAV_SECTIONS = [
  {
    label: NAV_COPY.sections.overview,
    items: [{ to: "/affiliate", label: NAV_COPY.common.dashboard, icon: NAV_ICONS.dashboard, end: true }],
  },
  {
    label: NAV_COPY.sections.sourcing,
    items: [{ to: "/affiliate/jobs", label: NAV_COPY.common.openJobs, icon: NAV_ICONS.openJobs }],
  },
  {
    label: NAV_COPY.sections.finance,
    items: [{ to: "/affiliate/payments", label: NAV_COPY.common.payments, icon: NAV_ICONS.payments }],
  },
];

export function AffiliateLayout() {
  const profileQuery = useQuery({ queryKey: ["affiliate-profile"], queryFn: affiliateApi.myProfile });
  const showKycNav = !identityMarketplaceOpen(profileQuery.data?.kyc_status);
  const kycIndicator =
    profileQuery.data?.kyc_status === "submitted"
      ? { label: "In review", color: "blue" }
      : profileQuery.data?.kyc_status === "rejected"
        ? { label: "Fix required", color: "red" }
        : { label: "Action needed", color: "orange" };

  const navSections = showKycNav
    ? [
        {
          ...NAV_SECTIONS[0],
          items: [
            ...NAV_SECTIONS[0].items,
            {
              to: "/kyc",
              label: identityKycNavLabel(profileQuery.data?.kyc_status),
              icon: NAV_ICONS.kyc,
              color: profileQuery.data?.kyc_status === "rejected" ? "red" : "orange",
              badge: true,
              badgeLabel: kycIndicator.label,
              badgeColor: kycIndicator.color,
              attention: profileQuery.data?.kyc_status !== "submitted",
            },
          ],
        },
        NAV_SECTIONS[1],
        NAV_SECTIONS[2],
      ]
    : NAV_SECTIONS;
  return (
    <RoleShell
      portalLabel="Affiliate Portal"
      logoTo="/affiliate"
      navSections={navSections}
      profileTo="/affiliate/profile"
      avatarColor="violet"
      avatarFallback="A"
      navbarExtra={
        <ShareIntakeLinkButton
          label="Share candidate link"
          variant="subtle"
          size="sm"
          fullWidth
        />
      }
    />
  );
}
